export default [
  {
    id: 2,
    name: "Aragorn II Elessar Telcontar",
    age: 87,
    date: "February 29",
    image:
      "https://upload.wikimedia.org/wikipedia/en/thumb/3/35/Aragorn300ppx.png/170px-Aragorn300ppx.png",
  },
  {
    id: 3,
    name: "Django Freeman",
    age: 36,
    date: "July 13",
    image:
      "https://pbs.twimg.com/profile_images/1343818057425313793/6G8U2Doj_400x400.jpg",
  },
  {
    id: 5,
    name: "Enzo Gorlami",
    age: 35,
    date: "December 31",
    image:
      "http://polisharmy.pl/uploads/monthly_2018_05/a4a2787b3ed6ef86e6ba3b726bf175d2dcb548ee_full.jpg.7cc60a5d3afc22cb8d052764bc27803e.jpg",
  },
  {
    id: 1,
    name: "Kratos",
    age: 451,
    date: "March 10",
    image: "https://avatarfiles.alphacoders.com/132/thumb-1920-132539.jpg",
  },
];
